import { useContext } from 'react';
import { UserContext } from 'contexts/ConfigContext';
import { ConfigKeys } from 'utils/Enums';
import { getConfig } from 'utils/helperMethods';

export const useGetCurrencyForTenant = () => {
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig(ConfigKeys.COMMON_CONFIG, appConfig);
    const { currency } = commonConfig.units;
    return currency;
};
